
import React, { useContext, Children } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from 'react-router-dom'
import Button from '../formfields/Button'
import Spinner from '../ui-elements/Spinner'
import YellowAlert from '../ui-elements/YellowAlert'
import QuestionText from './QuestionText'
import QuestionNumber from './QuestionNumber'
import QuestionYesOrNo from './QuestionYesOrNo'



type MultiFieldOptionProps = {
    question: ObjectStringKeyAnyValue
    questionId: string
    optionId: string
    setQuestionAnswerValue: React.Dispatch<React.SetStateAction<any>>
}

function MultiFieldOption({
    question,
    questionId,
    optionId,
    setQuestionAnswerValue

}: MultiFieldOptionProps) {

    const {
        tableData
    } = useContext(GlobalContext)


    const thisOption = question.MultiFieldQuestionOptions[optionId]
    const questionText = thisOption.QuestionText
    const questionFormat = thisOption.QuestionFormat
    const validFormats = ['Text', 'Number', 'YesOrNo', 'Date', 'Time', 'DateAndTime']

    const setMultiFieldQuestionAnswer = (value: string) => {
        
    }

    if (!validFormats.includes(questionFormat)){
        console.error(`Invalid question format: ${questionFormat}`)
        return null
    }

    return <div className={`flex flex-col gap-2`}>
        <p className={`font-bold`}>{questionText}</p>
        {questionFormat === 'Text' && <QuestionText
            setQuestionAnswer={setMultiFieldQuestionAnswer}
            defaultValue={''}
        />}
        {questionFormat === 'Number' && <QuestionNumber
            setQuestionAnswer={setMultiFieldQuestionAnswer}
            defaultValue={''}
        />}
        {questionFormat === 'YesOrNo' && <QuestionYesOrNo
            setQuestionAnswer={setMultiFieldQuestionAnswer}
            defaultValue={''}
        />}
        {questionFormat === 'Date' && <QuestionText
            setQuestionAnswer={setMultiFieldQuestionAnswer}
            defaultValue={''}
        />}
        {questionFormat === 'Time' && <QuestionNumber
            setQuestionAnswer={setMultiFieldQuestionAnswer}
            defaultValue={''}
        />}
        {questionFormat === 'DateAndTime' && <QuestionYesOrNo
            setQuestionAnswer={setMultiFieldQuestionAnswer}
            defaultValue={''}
        />}
    </div>
}



type Props = {
    question: ObjectStringKeyAnyValue
    questionId: string
    setQuestionAnswerValue: React.Dispatch<React.SetStateAction<any>>
}

function QuestionMultipleFields({
    question,
    questionId,
    setQuestionAnswerValue
}: Props) {

    const {
        tableData
    } = useContext(GlobalContext)





    return <div className={`w-full flex flex-col gap-4`}>

        {question.MultiFieldQuestionOptions && Object.keys(question.MultiFieldQuestionOptions).length > 0 ? Object.keys(question.MultiFieldQuestionOptions).map((optionId: string, index: number) => {


            return <MultiFieldOption
                key={optionId}
                question={question}
                questionId={questionId || ''}
                optionId={optionId}
                setQuestionAnswerValue={setQuestionAnswerValue}
            />
        }) :

            <YellowAlert>No field names added</YellowAlert>}

    </div>
}
export default QuestionMultipleFields